import Toast from "../../../common/components/ui/toast";
import Dashboard from "../../../common/components/layout/Dashboard";
import { ToastProvider } from "../../../common/components/ui/toast/toast.provider";
import { AuditsTableVehiclesMaintenance } from "./../components/AuditsTableVehiclesMaintenance";

function AuditsVehiclesManintenancePage() {
  return (
    <ToastProvider>
      <Dashboard>
        <AuditsTableVehiclesMaintenance />
        <Toast />
      </Dashboard>
    </ToastProvider>
  )
}

export default AuditsVehiclesManintenancePage;
